import { render } from "./Home.vue?vue&type=template&id=1354f718&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=1354f718&scoped=true&lang=css"

import exportComponent from "/home/regie/projects-2.0/soo-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1354f718"]])

export default __exports__